import React, {useState, useEffect} from "react";
import {TextField, DialogContent, DialogActions} from "@material-ui/core";
import {Button, Grid} from "@material-ui/core";
import {Autocomplete} from "@material-ui/lab";
import axios from "axios";
import {Close, Save} from "@material-ui/icons";
import {getCookie} from "../../../components/auth/Helpers";

import "react-dropzone-uploader/dist/styles.css";

const FilterComponent = (props) => {
  const token = getCookie("token");
  const [clientsList, setClientsList] = useState([]);
  const [fridgesTypesList, setFridgesTypesList] = useState([]);
  const [statusList, setStatusList] = useState([
    "Operational",
    "Quarantine",
    "Major Maintenance",
    "Damaged",
    "Discontinued",
  ]);
  const [prevStatusList, setPrevStatusList] = useState(["Due", "Recomended"]);

  useEffect(() => {
    const fetchData = async () => {
      await axios
        .all([
          axios.get(`${process.env.REACT_APP_BASE_URL}/clients`, {
            headers: {Authorization: `Bearer ${token}`},
          }),
          axios.get(`${process.env.REACT_APP_BASE_URL}/fridgesTypes`, {
            headers: {Authorization: `Bearer ${token}`},
          }),
        ])
        .then((response) => {
          setClientsList(response[0].data);
          setFridgesTypesList(response[1].data);
        });
    };
    fetchData();
  }, []);

  const handleChangeAutoComplete = (e, newValue, name) => {
    if (newValue) {
      props.setFilterFormValues((prev) => ({
        ...prev,
        [name]: newValue,
      }));
    } else {
      props.setFilterFormValues((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const handleSearchDate = (e) => {
    const {name, value} = e.target;
    if (value) props.setFilterFormValues({...props.filterFormValues, [name]: value});
  };

  const handleOnSubmit = async () => {
    let filterArray = [];

    if (props.filterFormValues.condition)
      filterArray.push(`condition=${props.filterFormValues.condition.id}`);
    if (props.filterFormValues.is_new) filterArray.push(`is_new=${props.filterFormValues.is_new.id}`);
    if (props.filterFormValues.booking) filterArray.push(`booking=${props.filterFormValues.booking.id}`);
    if (props.filterFormValues.location) filterArray.push(`location=${props.filterFormValues.location.id}`);
    if (props.filterFormValues.store) filterArray.push(`location_id=${props.filterFormValues.store._id}`);
    if (props.filterFormValues.warehouse)
      filterArray.push(`location_id=${props.filterFormValues.warehouse._id}`);

    if (props.filterFormValues.client._id) filterArray.push(`clientId=${props.filterFormValues.client._id}`);
    if (props.filterFormValues.fridgesType._id)
      filterArray.push(`fridgeTypeId=${props.filterFormValues.fridgesType._id}`);
    if (props.filterFormValues.prevStatus)
      filterArray.push(`prevStatus=${props.filterFormValues.prevStatus}`);
    if (props.filterFormValues.status) filterArray.push(`status=${props.filterFormValues.status}`);
    if (props.filterFormValues.fromDate) filterArray.push(`fromDate=${props.filterFormValues.fromDate}`);
    if (props.filterFormValues.toDate) filterArray.push(`toDate=${props.filterFormValues.toDate}`);
    await axios(
      `${process.env.REACT_APP_BASE_URL}/cabinets?limit=${
        props.pagingInfo.limit
      }&skip=0&searchEntry=${props.searchEntry}&${filterArray.join("&")}`,
      {
        responseType: "json",
        headers: {Authorization: `Bearer ${token}`},
      }
    )
      .then(function (response) {
        props.setTabIndex(0);
        props.setCountLive({total: response.data.count, data: response.data.tabs});

        // Reset to page 0 so the paging state stays in sync with the freshly filtered result set -
        // otherwise a later page change reuses the old skip and can land past the end of the new results.
        props.setPagingInfo({...props.pagingInfo, page: 0, skip: 0, count: response.data.count});
        props.setItems(response.data.data);
        props.setOpenDialog(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  return (
    <>
      <DialogContent dividers>
        <h3>Cabinets Report Filter</h3>
      </DialogContent>
      <DialogContent dividers>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={4}>
            <Autocomplete
              id="ClientInput"
              options={clientsList || {}}
              value={props.filterFormValues.client || {}}
              getOptionLabel={(option) => (Object.keys(option).length !== 0 ? option.name : "")}
              fullWidth
              onChange={(e, newValue) => handleChangeAutoComplete(e, newValue, "client")}
              renderInput={(params) => <TextField {...params} label="Client" name="client" />}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Autocomplete
              id="fridgesTypeInput"
              options={fridgesTypesList || {}}
              value={props.filterFormValues.fridgesType || {}}
              getOptionLabel={(option) => (Object.keys(option).length !== 0 ? option.name : "")}
              fullWidth
              onChange={(e, newValue) => handleChangeAutoComplete(e, newValue, "fridgesType")}
              renderInput={(params) => <TextField {...params} label="Fridges Type" />}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Autocomplete
              id="statusInput"
              options={statusList}
              value={props.filterFormValues.status || {}}
              getOptionLabel={(option) => (Object.keys(option).length !== 0 ? option : "")}
              fullWidth
              onChange={(e, newValue) => handleChangeAutoComplete(e, newValue, "status")}
              renderInput={(params) => <TextField {...params} label="Status" />}
            />
          </Grid>

          <Grid item xs={12} sm={4}>
            <Autocomplete
              id="condition"
              options={[
                {id: "Used", name: "Used"},

                {id: "New", name: "New"},
              ]}
              value={props.filterFormValues.condition || {}}
              getOptionLabel={(option) => (Object.keys(option).length !== 0 ? option.name : "")}
              fullWidth
              onChange={(e, newValue) => handleChangeAutoComplete(e, newValue, "condition")}
              renderInput={(params) => <TextField {...params} label="condition" name="condition" />}
            />
          </Grid>

          <Grid item xs={12} sm={4}>
            <Autocomplete
              id="prevStatusInput"
              options={prevStatusList}
              value={props.filterFormValues.prevStatus || {}}
              getOptionLabel={(option) => (Object.keys(option).length !== 0 ? option : "")}
              fullWidth
              onChange={(e, newValue) => handleChangeAutoComplete(e, newValue, "prevStatus")}
              renderInput={(params) => <TextField {...params} label="Preventive Status" />}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              id="fromDate"
              name="fromDate"
              label="From Date"
              type="date"
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
              onChange={handleSearchDate}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              id="toDate"
              name="toDate"
              label="To Date"
              type="date"
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
              onChange={handleSearchDate}
            />
          </Grid>

          <Grid item xs={12} sm={4}>
            <Autocomplete
              id="location"
              options={[
                {id: "store", name: "Store"},

                {id: "warehouse", name: "Warehouse"},
              ]}
              value={props.filterFormValues.location || {}}
              getOptionLabel={(option) => (Object.keys(option).length !== 0 ? option.name : "")}
              fullWidth
              onChange={(e, newValue) => handleChangeAutoComplete(e, newValue, "location")}
              renderInput={(params) => <TextField {...params} label="Location" name="location" />}
            />
          </Grid>

          {props.filterFormValues.location && props.filterFormValues.location.id == "store" && (
            <Grid item xs={12} sm={4}>
              <Autocomplete
                id="store"
                options={props.storesList}
                value={props.filterFormValues.store || {}}
                getOptionLabel={(option) => (Object.keys(option).length !== 0 ? option.name : "")}
                fullWidth
                onChange={(e, newValue) => handleChangeAutoComplete(e, newValue, "store")}
                renderInput={(params) => <TextField {...params} label="Store" name="store" />}
              />
            </Grid>
          )}

          {props.filterFormValues.location && props.filterFormValues.location.id == "warehouse" && (
            <Grid item xs={12} sm={4}>
              <Autocomplete
                id="warehouse"
                options={props.warehousesList}
                value={props.filterFormValues.warehouse || {}}
                getOptionLabel={(option) => (Object.keys(option).length !== 0 ? option.name : "")}
                fullWidth
                onChange={(e, newValue) => handleChangeAutoComplete(e, newValue, "warehouse")}
                renderInput={(params) => <TextField {...params} label="Site" name="warehouse" />}
              />
            </Grid>
          )}

          <Grid item xs={12} sm={4}>
            <Autocomplete
              id="booking"
              options={[
                {id: "booked", name: "Booked"},

                {id: "not_booked", name: "Not Booked"},
              ]}
              value={props.filterFormValues.booking || {}}
              getOptionLabel={(option) => (Object.keys(option).length !== 0 ? option.name : "")}
              fullWidth
              onChange={(e, newValue) => handleChangeAutoComplete(e, newValue, "booking")}
              renderInput={(params) => <TextField {...params} label="Booking" name="booking" />}
            />
          </Grid>

          <Grid item xs={12} sm={4}>
            <Autocomplete
              id="is_new"
              options={[
                {id: "new", name: "Is Received New"},

                {id: "not_new", name: "Not Received New"},
              ]}
              value={props.filterFormValues.is_new || {}}
              getOptionLabel={(option) => (Object.keys(option).length !== 0 ? option.name : "")}
              fullWidth
              onChange={(e, newValue) => handleChangeAutoComplete(e, newValue, "is_new")}
              renderInput={(params) => <TextField {...params} label="Received New" name="is_new" />}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          variant="outlined"
          color="primary"
          size="large"
          className="btn btn--save"
          onClick={() => props.setOpenDialog(false)}
          startIcon={<Close />}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          size="large"
          className="btn btn--save"
          onClick={handleOnSubmit}
          startIcon={<Save />}
        >
          Save
        </Button>
      </DialogActions>
    </>
  );
};

export default FilterComponent;
